import { Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
    selector: 'jeopardy-multiplayer',
    templateUrl: './multiplayer.component.html',
    styleUrls: ['./multiplayer.component.scss'],
    imports: [RouterOutlet]
})
export class MultiplayerComponent implements OnInit {

  ngOnInit(): void {
  }

}
